import React,{ useState, useEffect } from 'react';
import { 
    Alert,
    Card,
    Button
} from 'antd';

import {
    GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3';

import { 
    RightOutlined,
    PhoneOutlined,
    MessageOutlined
} from '@ant-design/icons';

import DefaultMenu from './DefaultMenu';
import SupportMenu from './SupportMenu';
import SalesMenu from './SalesMenu';
import CareMenu from './CareMenu';
import CompanyMenu from './CompanyMenu';
import ComplaintsMenu from './ComplaintsMenu';

const siteDomain = headerVars.siteDomain;

function ContactForm() {
    const [ salesActive, setSalesActive ] = useState( false );
    const [ supportActive, setSupportActive ] = useState( false );
    const [ careActive, setCareActive ] = useState( false );
    const [ companyActive, setCompanyActive ] = useState( false );
    const [ complaintsActive, setComplaintsActive ] = useState( false );

    const captchaKey = "6LdmP8QkAAAAACX1XkPWEZ08HGoIkk1nClZiagMJ";

    useEffect(() => {
        const url_string = window.location.href;
        let url = new URL(url_string);
        const hardwareType = url.searchParams.get("form");
        
        switch( hardwareType ) {
            case 'complaints':
            setComplaintsActive( true );
            break;
        }
    }, []);

    const handleMenuItemClick = ( e ) => {
        let isActive = null

        switch( e.currentTarget.id ) {
            case 'sales-card':
            isActive = salesActive ? false : true;
            setSalesActive( isActive );
            setSupportActive( false );
            setCareActive( false );
            setCompanyActive( false );
            setComplaintsActive( false );
            break;
            case 'support-card':
            isActive = supportActive ? false : true;
            setSupportActive( isActive );
            setSalesActive( false );
            setCareActive( false );
            setCompanyActive( false );
            setComplaintsActive( false );
            break;
            case 'care-card':
            isActive = careActive ? false : true;
            setCareActive( isActive );
            setSupportActive( false );
            setSalesActive( false );
            setCompanyActive( false );
            setComplaintsActive( false );
            break;
            case 'company-card':
            isActive = companyActive ? false : true;
            setCompanyActive( isActive );
            setSupportActive( false );
            setCareActive( false );
            setSalesActive( false );
            setComplaintsActive( false );
            break;
            case 'complaints-card':
            isActive = complaintsActive ? false : true;
            setComplaintsActive( isActive );
            setSupportActive( false );
            setCareActive( false );
            setCompanyActive( false );
            setSalesActive( false );
            break;
        }
    }

    const handleShowChatClick = () => {
        showChat( jQuery("#chatWindow") );
    }

    const getFormMarkup = () => {
        if( salesActive ) {
            return(
                <GoogleReCaptchaProvider
                    reCaptchaKey={ captchaKey }>
                    <SalesMenu />
                </GoogleReCaptchaProvider>
            )
        }
        else if( supportActive ) { return( <SupportMenu /> ) }
        else if( careActive ){ return( <CareMenu /> ) }
        else if( companyActive ){ return( <CompanyMenu /> ) }
        else if( complaintsActive ) {
            return( 
            <GoogleReCaptchaProvider
                reCaptchaKey={ captchaKey }>
                <ComplaintsMenu />
            </GoogleReCaptchaProvider> 
            )
        }else { return( <DefaultMenu /> ) }
    }

    return (
        <div className="react-contact-form">
            <h1>How can we help?</h1>
            <p>Learn more about our services, find answers, troubleshoot problems, request help and more.</p>
            <Alert
                message=""
                className='services-alert'
                description={
                    <span>Online service changes or cancellations are not possible at this time.<br/>
                    Our Customer Care team is available to assist you between the hours of 8:00am - 9:00pm via phone <a href="tel:1-866-434-5888" >1-866-434-5888</a> or <a class="live-chat-link" tabindex="0">live Chat</a></span>
                }
                banner
                closable
            />
            <div className='contact-form-content-container'>
                <div className='card-menu'>
                    <Card
                        id="sales-card"
                        className={ ( salesActive ) ? "contact-menu-card active" : "contact-menu-card" }
                        onClick={ handleMenuItemClick }
                    >
                        <div className='card-contents'>
                            <div className='card-status-icon'></div>
                            <div className='card-copy'>
                                <h3>Sales</h3>
                                <span>Ready to upgrade or explore new service options?</span>
                            </div>
                        </div>
                    </Card>
                    <Card
                        id="support-card"
                        className={ ( supportActive ) ? "contact-menu-card active" : "contact-menu-card" }
                        onClick={ handleMenuItemClick }
                    >
                        <div className='card-contents'>
                            <div className='card-status-icon'></div>
                            <div className='card-copy'>
                                <h3>Technical Support</h3>
                                <span>Facing technical issues or need service assistance?</span>
                            </div>
                        </div>
                    </Card>
                    <Card
                        id="care-card"
                        className={ ( careActive ) ? "contact-menu-card active" : "contact-menu-card" }
                        onClick={ handleMenuItemClick }
                    >
                        <div className='card-contents'>
                            <div className='card-status-icon'></div>
                            <div className='card-copy'>
                                <h3>Customer Care or Billing</h3>
                                <span>Do you need help managing your account or with your bill?</span>
                            </div>
                        </div>
                    </Card>
                    <Card
                        id="company-card"
                        className={ ( companyActive ) ? "contact-menu-card active" : "contact-menu-card" }
                        onClick={ handleMenuItemClick }
                    >
                        <div className='card-contents'>
                            <div className='card-status-icon'></div>
                            <div className='card-copy'>
                                <h3>Company Contacts</h3>
                                <span>Need to connect to a specific department?</span>
                            </div>
                        </div>
                    </Card>
                    <Card
                        id="complaints-card"
                        className={ ( complaintsActive ) ? "contact-menu-card active" : "contact-menu-card" }
                        onClick={ handleMenuItemClick }
                    >
                        <div className='card-contents'>
                            <div className='card-status-icon'></div>
                            <div className='card-copy'>
                                <h3>Complaints and Resolutions</h3>
                                <span>Share your concerns or feedback with us.</span>
                            </div>
                        </div>
                    </Card>
                </div>
                <div className='form-container'> { getFormMarkup() } </div>
            </div>
        </div>
    )
}

export default ContactForm
